module.exports = __webpack_public_path__ + "img/png.05d3141c.svg";